module.exports = __webpack_public_path__ + "static/desktop/img/iPastBook-logo.4ef12a4f.svg";